import React from 'react';
import { DollarSign, PenTool, Shirt, CheckSquare, ShoppingBag } from 'lucide-react';
import { Container } from '../Container';
export function TrustBar() {
  const items = [{
    icon: DollarSign,
    text: 'Factory Direct Pricing'
  }, {
    icon: PenTool,
    text: 'Free Initial Art Mockups'
  }, {
    icon: CheckSquare,
    text: 'Fast Turn Times'
  }, {
    icon: Shirt,
    text: 'Product / Size Samples'
  }, {
    icon: ShoppingBag,
    text: 'Team Stores Available'
  }];
  return <div className="bg-gray-100 border-b border-gray-200 py-6" data-id="element-298">
      <Container data-id="element-299">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-300">
          {items.map((item, index) => <div key={index} className="flex items-center justify-center lg:justify-start space-x-3" data-id="element-301">
              <div className="bg-white p-2 rounded-full shadow-sm text-pts-red" data-id="element-302">
                <item.icon className="h-5 w-5" data-id="element-303" />
              </div>
              <span className="font-semibold text-sm text-gray-800 leading-tight" data-id="element-304">
                {item.text}
              </span>
            </div>)}
        </div>
      </Container>
    </div>;
}